export const T = {
  en_GB: {
    name: "Name",
    ticker: "Ticker",
    currency: "Currency",
    actions: "Actions",
    edit: "Edit",
    delete: "Delete",
    viewChart: "View chart",
    noData: "No time series data available.",
  },
  nb_NO: {
    name: "Navn",
    ticker: "Ticker",
    currency: "Valuta",
    actions: "Handlinger",
    edit: "Rediger",
    delete: "Slett",
    viewChart: "Se diagram",
    noData: "Ingen tidsseriedata tilgjengelig.",
  },
} as const;
